// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
import uuid from 'uuid/v4';

let uniqueId = 0;
export const createLocalIdByCount = (): string => {
	return `${uniqueId++}`;
};

export const createLocalId = (): string => {
	if (process.env.NODE_ENV !== 'production') {
		return createLocalIdByCount();
	}
	// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
	return uuid();
};

export const resetLocalIdByCount = () => {
	uniqueId = 0;
};
